<section>
  <div class="cert__tab-header">
    <div>
      <p>
        {{ "Cert.PageDescription3" | translate }}
        <a
          href="https://servicedesk.surf.nl/wiki/spaces/WIKI/pages/198967846/DNS+Firewall"
          target="_blank"
          rel="noopener noreferrer"
        >
          wiki</a
        >.
      </p>
    </div>
  </div>
  <div class="cert__filter-and-chart">
    <cert-filter-dns [prefixes]="prefixes()" (filtersChanged)="onFiltersChanged($event)"></cert-filter-dns>
    <div></div>
    <i class="cert__filter-divider">
      <span></span>
      <span></span>
      <span></span>
    </i>
    <cert-chart-generic
      [series]="dnsFirewallChartSeries()"
      [legendGroups]="dnsFirewallChartLegendGroups()"
      [loading]="loadingState()"
      [legendTitle]="'Cert.RPZFeed' | translate"
      [chartTitle]="''"
    ></cert-chart-generic>
  </div>
  <cert-dns-firewall-table
    [dnsFirewallLogs]="dnsFirewallLogs()"
    [pageInfo]="pageInfo()"
    (paginationChanged)="onPaginationChanged($event)"
    (sortingChanged)="onSortingChanged($event)"
    (pageSizeChanged)="onPageSizeChanged($event)"
  ></cert-dns-firewall-table>
</section>
